import React, { useState } from "react";
import "./Payouts.css";
import FinanceOverview from "./FinanceOverview";
import SalaryPayout from "./SalaryPayout";
import SalaryOnHand from "./SalaryOnHand";
import SalaryRevision from "./SalaryRevision";

const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("OVERVIEW");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "OVERVIEW":
        return <FinanceOverview />;
      case "SALARY PAYOUT":
        return <SalaryPayout />;
      case "SALARY ON HAND":
        return <SalaryOnHand title="Salary On Hand" />;
      case "SALARY REVISION":
        return <SalaryRevision title="Salary Revision" />;
      default:
        return <DummySection />;
    }
  };

  const tabs = [
    "OVERVIEW",
    "SALARY PAYOUT",
    "SALARY ON HAND",
    "SALARY REVISION",
  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

